import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { smilDesignQuestionsConfig, smilDesignQuestionsConfigFirstFit } from '../pages/SmileDesign/SmileDesignQuestions';

/**
 * Provides the Smile Design question configuration for the current display mode.
 */
const useSmileDesignConfig = ({ formValues, previewAfterSubmitbyisMarieGroup, isMarieGroup, isTWGroup, isSEAGroup, isUpSellTab }) => {
    const displayFirstFitFlag = useSelector((state) => state.globalReducer.displayFirstFitFlag);
    const config = useMemo(() => {
        const questionConfig = displayFirstFitFlag ? smilDesignQuestionsConfigFirstFit : smilDesignQuestionsConfig;
        return questionConfig(
            formValues,
            previewAfterSubmitbyisMarieGroup !== undefined ? previewAfterSubmitbyisMarieGroup : isMarieGroup,
            isUpSellTab,
            isTWGroup,
            isSEAGroup
        );
    }, [displayFirstFitFlag, formValues, previewAfterSubmitbyisMarieGroup, isMarieGroup, isTWGroup, isSEAGroup, isUpSellTab]);

    return {
        config,
    };
};

export default useSmileDesignConfig;
